// extracted by mini-css-extract-plugin
export var divider = "_2r-0";
export var dividerText = "_2r-1";